import { Box, Text, Link, VStack, Tooltip } from '@chakra-ui/react'
import { formatDateFromNow } from '@/shared/parse'
import { IFile } from '@/shared/IFile'

export const CourseStepFileGroup = ({ files, isSpecialFile }: {
  files: IFile[];
  isSpecialFile: (file: IFile) => boolean | undefined;
}) => {

  const groups = new Map<string, IFile[]>();
  files.forEach(file => {
    const title = file.title?.trim() || '';
    const name = file.name?.trim() || '';
    const groupTitle = (!title || title === name) ? 'Other' : title;
    
    if (!groups.has(groupTitle)) {
      groups.set(groupTitle, []);
    }
    groups.get(groupTitle)!.push(file);
  });

  return (
    Array.from(groups.entries())
      .sort(([titleA, filesA], [titleB, filesB]) => {
        // Other always comes last
        if (titleA === 'Other') return 1;
        if (titleB === 'Other') return -1;
        
        // Special files come first
        const hasSpecialA = filesA.some(file => isSpecialFile(file));
        const hasSpecialB = filesB.some(file => isSpecialFile(file));
        
        if (hasSpecialA && !hasSpecialB) return -1;
        if (!hasSpecialA && hasSpecialB) return 1;
        
        // Then alphabetical
        return titleA.localeCompare(titleB, undefined, { numeric: true });
      })
      .map(([title, groupFiles]) => {
        const hasSpecialFile = groupFiles.some(file => isSpecialFile(file));

        return (
          <Box key={title} pl='4'>
            {groupFiles.length === 1 ? (
              <Link href={groupFiles[0].downloadUrl} fontWeight={700} colorScheme={hasSpecialFile ? 'secondary' : 'brand'} mb='2'>
                {title}
              </Link>
            ) : (
              <Text fontWeight={700} color={hasSpecialFile ? 'secondary.500' : 'brand.500'} mb='2'>
                {title}
              </Text>
            )}
            <VStack align='start' spacing="1" ml='2'>
              {groupFiles
                .sort((a, b) => a.name.localeCompare(b.name, undefined, { numeric: true }))
                .map(file => (
                  <Tooltip key={file.name} openDelay={1000} label={`modified ${formatDateFromNow(file.modified)} by ${file.modifiedBy?.name}`}>
                    <Link color='fg.muted' textStyle="sm" href={file.downloadUrl}>
                      {file.name}
                    </Link>
                  </Tooltip>
                ))}
            </VStack>
          </Box>
        );
      })
  );
};
